import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CategoryBlobCard from "@/components/CategoryBlobCard";

export default function Categories() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then(r => setCats(r.data)); }, []);
  // Show only top-level (no parent_slug)
  const topLevel = cats.filter(c => !c.parent_slug);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-display text-4xl uppercase mb-8">Të gjitha kategoritë</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 pb-4">
        {topLevel.map(c => (
          <CategoryBlobCard key={c.id} cat={c} testid={`cat-card-${c.slug}`} />
        ))}
      </div>
    </div>
  );
}
